// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1dEvq","header":"ReportDetails_header__1x12y","title":"ReportDetails_title__1I2yK","left":"ReportDetails_left__rAxwH"};